import { render, staticRenderFns } from "./PopupCreateOrUpdateTitleItem.vue?vue&type=template&id=7a2ddf8a&scoped=true&"
import script from "./PopupCreateOrUpdateTitleItem.vue?vue&type=script&lang=js&"
export * from "./PopupCreateOrUpdateTitleItem.vue?vue&type=script&lang=js&"
import style0 from "./PopupCreateOrUpdateTitleItem.vue?vue&type=style&index=0&id=7a2ddf8a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a2ddf8a",
  null
  
)

/* custom blocks */
import block0 from "@/locales/modules/TitleTranslate.json?vue&type=custom&index=0&blockType=i18n&issuerPath=%2FUsers%2Flike%2FDocuments%2FComay%2FSources%2FFe%2Flink-fe%2Fsrc%2Fviews%2Fapps%2Ftitle%2FPopupCreateOrUpdateTitleItem.vue"
if (typeof block0 === 'function') block0(component)

export default component.exports